import camelCase from 'lodash/camelCase';
import type { CSSProperties } from 'react';

/**
 * Converts an inline CSS string to an object that React can use for its "style" prop
 * @param str a css inline string
 * @returns a CSSProperties object to use in React JSX
 */
export function InlineCSSToReactStyle(
  str: string | null | undefined
): CSSProperties {
  str ??= '';
  const style: Record<string, string> = {};
  str.split(';').forEach((el) => {
    const [property, value] = el.split(':');
    if (!property) return;

    const formattedProperty = camelCase(property.trim());
    style[formattedProperty] = value.trim();
  });

  return style;
}
